import type { ReactNode } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { ArrowRightIcon } from '@src/components/icons/ArrowRightIcon';
import { testIdAttr, testIdFor } from '@src/components/testId';
import { Typography } from '@src/components/Typography/Typography';
import { isInAppHref } from '@src/routing/href';
import './ExchangeCard.css';

export interface ExchangeCardProps {
  href: string;
  tag: string;
  title: string;
  image: string;
  icon?: ReactNode;
  detailsLabel?: string;
  testId?: string;
}

/** Illustrated landing-format card — image, tag, title, go. */
export function ExchangeCard({
  href,
  tag,
  title,
  image,
  icon,
  detailsLabel,
  testId,
}: ExchangeCardProps) {
  const body = (
    <>
      <span className="home-exchange-card__art" aria-hidden="true">
        {icon ?? <img className="home-exchange-card__image" src={image} alt="" />}
      </span>
      <span className="home-exchange-card__body">
        <span className="home-exchange-card__copy">
          {!icon && (
            <Typography as="span" role="title/eyebrow" {...testIdAttr(testIdFor(testId, 'tag'))}>
              {tag}
            </Typography>
          )}
          <Typography as="h3" role="title/card" {...testIdAttr(testIdFor(testId, 'title'))}>
            {title}
          </Typography>
        </span>
        <span className="home-exchange-card__go">
          {detailsLabel ? <span>{detailsLabel}</span> : null}
          <span aria-hidden="true">
            <ArrowRightIcon />
          </span>
        </span>
      </span>
    </>
  );

  if (isInAppHref(href)) {
    return (
      <RouterLink
        className={`home-exchange-card${icon ? ' home-exchange-card--icon' : ''}`}
        to={href}
        {...testIdAttr(testId)}
      >
        {body}
      </RouterLink>
    );
  }

  return (
    <a
      className={`home-exchange-card${icon ? ' home-exchange-card--icon' : ''}`}
      href={href}
      {...testIdAttr(testId)}
    >
      {body}
    </a>
  );
}
